/**
 * Error thrown by bridge methods (e.g. `invoke`) that carries the backend
 * `errorType` alongside the message. The `withErrorDisplay` middleware inspects
 * `errorType` to decide whether to surface a Forge UI runtime error message; the error is
 * always rethrown so the app-side call still rejects.
 *
 * Pure (no React) so it can be thrown from the bridge method layer.
 */
export class ForgeAppError extends Error {
	readonly errorType: string;

	constructor(errorType: string, message?: string) {
		super(message ?? errorType);
		this.name = 'ForgeAppError';
		this.errorType = errorType;
		// Required for correct `instanceof` checks when transpiled to ES5.
		Object.setPrototypeOf(this, ForgeAppError.prototype);
	}
}
